import { computed, defineComponent, PropType, ref } from 'vue';
import { Media } from '@/common/domain/Media';
import { MediasInputVue } from '@/staff/primary/media-input';
import { MediaType } from '@/common/domain/MediaType';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'SingleImageInput',

  components: { MediasInputVue },

  props: {
    media: {
      type: Object as PropType<Media>,
      default: undefined,
    },
    touched: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    required: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },

  emits: ['updated-media'],

  setup(props, { emit }) {
    const { t } = useI18n();
    const unsupportedFile = ref(false);
    const medias = computed(() => (props.media ? [props.media] : []));

    const updateMedia = async (medias: Media[]) => {
      emit('updated-media', { value: medias[0] });
    };

    const setUnsupportedFileCount = (unsupported: boolean) => (unsupportedFile.value = unsupported);

    return {
      t,
      medias,
      MediaType,
      updateMedia,
      unsupportedFile,
      setUnsupportedFileCount,
    };
  },
});
